import React, { useMemo } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';

const ActionCommentsModal = ({
  show,
  onHide,
  taskId,
  comments,
  loading,
  coordinatorName,
  fetchActionComments
}) => {
  const actionCommentColumns = useMemo(() => [
    {
      name: 'Date',
      selector: row => row.createdDate,
      sortable: true,
      cell: row => new Date(row.createdDate).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }),
      width: '200px',
        custom: 'true',
    style: {
   

       textAlign:"center"
    },
    },
    {
      name: ' Task Coordinator',
      selector: row => row.createdByName,
      cell: row => (
        <div className="fw-medium">
          {row.createdByName}
        </div>
      ),
        center: true,
  width: '250px',
  custom: 'true',
    style: {
 

       textAlign:"center"
    },
    },
    {
      name: 'Action Comment',
      selector: row => row.actionComment,
      cell: row => (
        <div style={{ whiteSpace: 'pre-line', lineHeight: '1.5' }}>
          {row.actionComment}
        </div>
      ),
   
        style: {
 

       textAlign:"center"
    },
  grow: 2,
  width: '250px',
  custom: 'true',
    }
  ], []);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      scrollable
      backdrop="static"
    >
      <Modal.Header closeButton className="modal-customheader" closeVariant="">
        <Modal.Title className="custom-modaltitle">
         Action Taken Comments (TaskID {taskId})
          {comments.length > 0 && (
            <span className="badge bg-light text-dark ms-2">
              {comments.length} comment(s)
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="custommodal-body">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="btn-primary" />
            <p className="mt-2">Loading action comments...</p>
          </div>
        ) : (
          <DataTable
            columns={actionCommentColumns}
            data={comments}
            noDataComponent={
              <div className="text-center py-4">
                <i className="bi bi-chat-left fs-3 text-muted" />
                <p className="mt-2 fs-5">No action comments recorded</p>
                <p className="text-muted">All coordinator actions will appear here</p>
              </div>
            }
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[5, 10, 25]}
            highlightOnHover
            striped
            dense
               customStyles={{
          table: {
            style: {
              borderRadius: "0px",
              overflow: "hidden",
              border: "0px solid #dee2e6",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
            },
          },
          headRow: {
            style: {
              backgroundColor: "#04364A!important",
              minHeight: "48px",
            },
          },
          headCells: {
            style: {
              padding: "10px 14px",
              fontSize: "15px",
              fontWeight: "700",
              color: "white",
              textTransform: "uppercase",
                   backgroundColor: '#04364A',
                      textAlign: "center", 
        justifyContent: "center", 
            },
          },
          rows: {
            style: {
              borderBottom: "1px solid #e2e8f0",
              "&:hover": {
                backgroundColor: "#f9f9f9",
              },
            },
          },
          cells: {
            style: {
              padding: "10px 14px",
              fontSize: "14px",
              color: "#334155",
              textAlign: "center", 
        justifyContent: "center", 
            },
          },
        }}
          />
        )}
      </Modal.Body>
      {/* <Modal.Footer className="border-top">
        <Button variant="outline-btn-primary" onClick={onHide}>
          <i className="bi bi-x-lg me-2" />
          Close
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default ActionCommentsModal;